import {
  ICancellation,
  IFollowUpFormData,
} from '@principle-theorem/principle-core/interfaces';

export interface ICancelAppointment extends IFollowUpFormData, ICancellation {}
